<div data-test="r6ORiZrA" style="position: relative" [class.input_disabled]="disabled">
  <input
    data-test="TxbYS_Bx"
    [disabled]="disabled"
    *mdReaction="dateFormatStore.toIO('format') as dateFormat"
    [mdDisableInput]="!!inputDisabled"
    [placeholder]="format || dateFormat"
    [matDatepicker]="picker"
    [ngModel]="model"
    (click)="openPicker()"
    [ngClass]="inputClasses"
    (dateChange)="onDateChange($event)"
    [ngStyle]="inputStyles"
    class="input"
    type="text"
    #input
  />
  <mat-datepicker
    data-test="jku9if92"
    [startView]="startView"
    [panelClass]="['dropdown__wrap']"
    (monthSelected)="chosenMonthHandler($event)"
    (yearSelected)="chosenYearHandler($event)"
    #picker
  ></mat-datepicker>
  <label data-test="cbWBJCX0" class="form-group__field-prepend text-dark" *ngIf="prefix">
    {{ prefix }}:
  </label>
  <label data-test="ijpa-GHy" class="form-group__field-append link-light">
    <svg data-test="OVO_68SL" class="icon__icon-calendar-2" width="14px" height="13px">
      <use xlink:href="#icon-calendar-2"></use>
    </svg>
  </label>
</div>
